module.exports = __webpack_public_path__ + "static/media/tutorial-influence-1.b3812586.gif";